
(function () {
  if (window.__llWatchSyncBooted) return;
  window.__llWatchSyncBooted = true;

  /* ---- storage keys -------------------------------------------------- */
  var K_IDX    = 'll_watchlist_v2';       /* {v,u,i:{handle:±ms}} - the truth */
  var K_WATCH  = 'll_watchlist';          /* array - what hubs / PDP / alerts read */
  var K_LEGACY = 'll_preorder_watch';     /* array - older key, kept in step */
  var K_META   = 'll_watchlist_meta';     /* {v,u} */
  var K_DIRTY  = 'll_watchlist_dirty';    /* '1' when a save is still owed */
  var K_SKEW   = 'll_watchlist_skew';     /* ms to add to this device's clock */

  var MAX = 100;
  var PUSH_WAIT = 650;      /* debounce on a burst of bell taps */
  var PULL_GAP = 60000;     /* don't re-pull the FULL list more often than this */

  /* How often an open tab asks "changed?" - the cheap probe, not the full
     list. Fast while the shopper is plainly still using the site, then backing
     off, because a tab left open for an hour asking every ten seconds is 360
     pointless requests. Polling stops completely when the tab is hidden, so a
     phone in a pocket costs nothing. Raise these if IONOS ever feels it. */
  var POLL_FAST = 10000;    /* first minute after any activity */
  var POLL_SLOW = 30000;    /* after that, while still visible */
  var POLL_FAST_FOR = 60000;
  var TOMB_MS = 90 * 86400000;
  var RETRIES = [2000, 6000, 15000];

  var cfg = window.__llWatchCfg || { customerId: null, endpoint: '', token: null };

  /* ---- small helpers -------------------------------------------------- */
  function isArr(v) { return Object.prototype.toString.call(v) === '[object Array]'; }

  /* Every timestamp in this system is compared against every other one, across
     devices. Device clocks disagree - a phone a couple of minutes behind a
     laptop is ordinary - and using them raw meant the slower device always
     lost: remove a card on the phone, and the laptop's older "added" stamp
     still looked newer, so the removal was discarded and the card came back.

     So we do not use this device's clock for ordering. Every response carries
     the server's clock; we keep the offset and stamp everything in server
     time. One clock, one ordering, regardless of what any device believes the
     time is. */
  var CLOCK_SKEW = 0;
  try {
    var storedSkew = Number(localStorage.getItem(K_SKEW));
    if (isFinite(storedSkew)) CLOCK_SKEW = storedSkew;
  } catch (e) {}

  function now() { return Date.now() + CLOCK_SKEW; }

  function noteServerClock(j) {
    if (!j || typeof j.now !== 'number' || !isFinite(j.now)) return;
    var skew = j.now - Date.now();
    /* Ignore sub-second noise; a round trip is not a clock difference. */
    if (Math.abs(skew - CLOCK_SKEW) < 1000) return;
    CLOCK_SKEW = skew;
    try { localStorage.setItem(K_SKEW, String(skew)); } catch (e) {}
  }
  function readJSON(key, fb) {
    try { var v = localStorage.getItem(key); return v ? JSON.parse(v) : fb; }
    catch (e) { return fb; }
  }
  function writeJSON(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  function clean(h) {
    h = String(h == null ? '' : h).trim().toLowerCase();
    if (!h || h.length > 120) return '';
    return /^[a-z0-9][a-z0-9._-]*$/.test(h) ? h : '';
  }
  function uniq(list) {
    var out = [], seen = {};
    (isArr(list) ? list : []).forEach(function (h) {
      h = clean(h);
      if (!h || seen[h]) return;
      seen[h] = 1;
      out.push(h);
    });
    return out;
  }
  function maxAbs(idx) {
    var m = 0;
    for (var h in idx) {
      if (!Object.prototype.hasOwnProperty.call(idx, h)) continue;
      var a = Math.abs(idx[h]);
      if (a > m) m = a;
    }
    return m;
  }
  function sig(idx) {
    var keys = Object.keys(idx || {}).sort();
    return keys.map(function (k) { return k + ':' + idx[k]; }).join('|');
  }

  /* ---- the index ------------------------------------------------------ */

  /* Accepts v2 {i:{}}, v1 {h:[]}, or a bare array. */
  function indexFrom(raw) {
    var out = {};
    if (!raw) return out;

    if (raw.i && typeof raw.i === 'object' && !isArr(raw.i)) {
      for (var h in raw.i) {
        if (!Object.prototype.hasOwnProperty.call(raw.i, h)) continue;
        var k = clean(h), t = Number(raw.i[h]);
        if (k && t) out[k] = t;
      }
      return out;
    }

    var list = isArr(raw) ? raw : (raw.h || raw.handles || raw.list || []);
    var t0 = Number(raw && (raw.u || raw.updated)) || now();
    uniq(list).forEach(function (handle) { out[handle] = t0; });
    return out;
  }

  function toList(idx) {
    var adds = [];
    for (var h in idx) {
      if (!Object.prototype.hasOwnProperty.call(idx, h)) continue;
      if (idx[h] > 0) adds.push(h);
    }
    adds.sort(function (a, b) { return idx[b] - idx[a]; });
    return adds.slice(0, MAX);
  }

  /* Per-handle newest-wins. A tie keeps the item rather than losing it. */
  function merge(a, b) {
    var out = {};
    var h;
    for (h in a) if (Object.prototype.hasOwnProperty.call(a, h)) out[h] = a[h];
    for (h in b) {
      if (!Object.prototype.hasOwnProperty.call(b, h)) continue;
      if (!(h in out)) { out[h] = b[h]; continue; }
      var ca = Math.abs(out[h]), cb = Math.abs(b[h]);
      if (cb > ca || (cb === ca && b[h] > out[h])) out[h] = b[h];
    }
    return out;
  }

  function prune(idx) {
    var cutoff = now() - TOMB_MS;
    var adds = [], out = {}, h;
    for (h in idx) {
      if (!Object.prototype.hasOwnProperty.call(idx, h)) continue;
      if (idx[h] > 0) adds.push(h);
      else if (Math.abs(idx[h]) >= cutoff) out[h] = idx[h];
    }
    adds.sort(function (a, b) { return idx[b] - idx[a]; });
    adds.slice(0, MAX).forEach(function (k) { out[k] = idx[k]; });
    return out;
  }

  /* ---- local storage in/out ------------------------------------------- */

  function readIdx() {
    var stored = readJSON(K_IDX, null);
    if (stored && typeof stored === 'object' && stored.i) {
      var idx = indexFrom(stored);
      /* Self-heal. If something wrote the flat array without firing the change
         event, its handles would be silently dropped the next time we rewrite
         the array from the index. Fold those in as additions.

         Deliberately one-way: a handle missing from the array is NOT treated as
         a removal. Getting that wrong once would wipe the shopper's account
         list, and an extra item is a far cheaper mistake than a lost one. */
      var flat = readJSON(K_WATCH, null);
      if (isArr(flat)) {
        uniq(flat).forEach(function (h) {
          /* Only handles the index has never heard of. A handle carrying a
             tombstone must stay removed: the array simply has not been
             rewritten yet after a removal arrived from another device, and
             re-adding it here at now() would beat that removal and resurrect
             it on every device. */
          if (!(h in idx)) idx[h] = now();
        });
      }
      return idx;
    }

    /* First run under v2: fold the old flat array in. The timestamp comes from
       the old meta record if we have one, otherwise 1 - deliberately ancient,
       so a genuine removal already in the account always beats a stale local
       copy, while items the account has never seen still upload fine. */
    var list = readJSON(K_WATCH, null);
    if (!isArr(list)) list = readJSON(K_LEGACY, []);
    var meta = readJSON(K_META, {});
    var t = Number(meta && meta.u) || 1;
    var out = {};
    uniq(list).forEach(function (h) { out[h] = t; });
    return out;
  }

  var selfWrite = false;

  function writeIdx(idx, source) {
    idx = prune(idx);
    var list = toList(idx);
    var u = maxAbs(idx) || now();

    /* 'o' records whose list this is - see claimStorage(). null means guest. */
    writeJSON(K_IDX, { v: 2, u: u, o: cfg.customerId || null, i: idx });
    writeJSON(K_WATCH, list);
    writeJSON(K_LEGACY, list);
    if (cfg.customerId) writeJSON('ll_watchlist_c_' + cfg.customerId, list);
    writeJSON(K_META, { v: 2, u: u });

    selfWrite = true;
    try {
      document.dispatchEvent(new CustomEvent('ll:watchlist:change', {
        detail: { list: list, source: source || 'local' }
      }));
    } catch (e) {}
    selfWrite = false;

    return list;
  }

  /* Turn "here is the list now" into add / remove events against the index. */
  function applyList(list, at) {
    var t = at || now();
    var idx = readIdx();
    var want = {}, next = {}, h;
    uniq(list).forEach(function (k) { want[k] = 1; });
    for (h in idx) if (Object.prototype.hasOwnProperty.call(idx, h)) next[h] = idx[h];
    for (h in want) if (!(next[h] > 0)) next[h] = t;
    for (h in next) {
      if (!Object.prototype.hasOwnProperty.call(next, h)) continue;
      if (next[h] > 0 && !want[h]) next[h] = -t;
    }
    return next;
  }

  function isDirty() {
    try { return localStorage.getItem(K_DIRTY) === '1'; } catch (e) { return false; }
  }
  function setDirty(on) {
    try {
      if (on) localStorage.setItem(K_DIRTY, '1');
      else localStorage.removeItem(K_DIRTY);
    } catch (e) {}
  }

  /* ---- status ---------------------------------------------------------- */

  var syncState = 'idle';   /* idle | saving | ok | err | guest | auth */

  function setState(state, detail) {
    syncState = state;
    try {
      document.dispatchEvent(new CustomEvent('ll:watchlist:sync', {
        detail: { state: state, detail: detail || '', customerId: cfg.customerId }
      }));
    } catch (e) {}
    document.querySelectorAll('[data-sync-chip]').forEach(function (chip) {
      chip.setAttribute('data-sync-state', state);
    });
    document.querySelectorAll('[data-sync-status]').forEach(function (el) {
      if (state === 'saving') el.textContent = 'Saving across devices…';
      else if (state === 'ok') el.textContent = 'Synced across devices';
      else if (state === 'auth') el.textContent = 'Sign in again to sync';
      else if (state === 'err') el.textContent = detail || 'Sync pending — will retry';
      else if (state === 'guest') el.textContent = 'Log in to sync across devices';
      else el.textContent = '';
    });
  }

  /* ---- network --------------------------------------------------------- */

  function endpointUrl() {
    var url = cfg.endpoint || '';
    if (!url) return '';
    if (url.indexOf('http') === 0) return url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + (url.indexOf('/') === 0 ? url : '/' + url);
  }

  function canSync() {
    if (!cfg.customerId || !endpointUrl()) return false;
    /* Either we carry a signed token, or we are going through an App Proxy and
       Shopify signs the request for us. */
    return !!cfg.token || String(cfg.endpoint || '').indexOf('/apps/') === 0;
  }

  function headers() {
    var h = { 'Accept': 'application/json' };
    if (cfg.token) h['X-LL-Auth'] = cfg.token;
    return h;
  }

  var pushTimer = null;
  var retryAt = 0;
  var inFlight = false;
  var lastPull = 0;
  var pollTimer = null;
  var lastActivity = 0;
  var serverVersion = -1;   /* last 'u' we know the server had */

  function absorb(remote, source) {
    if (remote && typeof remote.u === 'number') serverVersion = remote.u;
    var incoming = indexFrom(remote);
    var local = readIdx();
    var merged = merge(local, incoming);
    if (sig(merged) !== sig(local)) writeIdx(merged, source || 'sync');
    return merged;
  }

  /* ---- polling --------------------------------------------------------- */

  function probe() {
    if (!canSync() || document.hidden) return Promise.resolve(false);
    return fetch(endpointUrl() + (endpointUrl().indexOf('?') > -1 ? '&' : '?') + 'probe=1', {
      method: 'GET',
      credentials: 'same-origin',
      headers: headers()
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      noteServerClock(j);
      if (!j || typeof j.u !== 'number') return false;
      /* Only pay for the full list when the number has actually moved. */
      if (j.u !== serverVersion) {
        serverVersion = j.u;
        return pull(true);
      }
      return false;
    }).catch(function () { return false; });
  }

  function pollDelay() {
    return (now() - lastActivity < POLL_FAST_FOR) ? POLL_FAST : POLL_SLOW;
  }

  function schedulePoll() {
    clearTimeout(pollTimer);
    if (!canSync() || document.hidden) return;
    pollTimer = setTimeout(function () {
      probe().then(schedulePoll);
    }, pollDelay());
  }

  function noteActivity() {
    lastActivity = now();
    schedulePoll();
  }

  function push(attempt) {
    attempt = attempt || 0;
    if (!canSync()) { setState('guest'); return Promise.resolve(false); }
    if (inFlight) { setDirty(true); return Promise.resolve(false); }

    var idx = readIdx();
    var body = { v: 2, u: maxAbs(idx) || now(), i: idx, h: toList(idx) };

    inFlight = true;
    setState('saving');

    return fetch(endpointUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: Object.assign({ 'Content-Type': 'application/json' }, headers()),
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 401) { var e = new Error('auth'); e.fatal = true; throw e; }
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      inFlight = false;
      noteServerClock(j);
      /* The server merges too, so its answer can contain another device's
         changes we have not seen. Fold them in. */
      if (j && (j.i || j.h)) absorb(j, 'sync');
      setDirty(false);
      setState('ok');
      return true;
    }).catch(function (err) {
      inFlight = false;
      setDirty(true);
      if (err && err.fatal) {
        /* Expired or bad token. A page load mints a fresh one - retrying the
           same dead token in a loop helps nobody. */
        setState('auth');
        return false;
      }
      setState('err');
      if (attempt < RETRIES.length) {
        clearTimeout(retryAt);
        retryAt = setTimeout(function () { push(attempt + 1); }, RETRIES[attempt]);
      }
      return false;
    });
  }

  function schedulePush(wait) {
    if (!canSync()) { setState('guest'); return; }
    setDirty(true);
    /* They are using it right now, so the other device probably is too - poll
       quickly for the next minute. */
    noteActivity();
    clearTimeout(pushTimer);
    pushTimer = setTimeout(function () { push(0); }, wait == null ? PUSH_WAIT : wait);
  }

  function pull(force) {
    if (!canSync()) return Promise.resolve(false);
    if (!force && now() - lastPull < PULL_GAP) return Promise.resolve(false);
    lastPull = now();

    return fetch(endpointUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: headers()
    }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    }).then(function (j) {
      noteServerClock(j);
      if (j && (j.i || j.h)) {
        var merged = absorb(j, 'sync');
        /* We hold something the account does not - send it up. */
        if (sig(merged) !== sig(indexFrom(j))) schedulePush(0);
        else setState('ok');
      } else {
        setState('ok');
      }
      return true;
    }).catch(function () {
      /* Offline or the endpoint is down. The local list is still correct for
         this device and any pending change stays flagged, so nothing is lost. */
      if (syncState !== 'saving') setState('err');
      return false;
    });
  }

  /* ---- boot ------------------------------------------------------------ */

  /* localStorage belongs to the browser, not to whoever is signed into it.
     On a shared computer the previous person's list is still sitting there
     when the next one logs in - and merging it would not just show them
     someone else's watchlist, it would push it up into their account, where
     it would then sync to all of their devices. So the index records who it
     belongs to, and a change of owner wipes it rather than merging it.

     The single exception is guest -> logged in, which is the same person
     claiming a list they built before signing in.

     Data written before this rule existed carries no owner. That is treated
     as someone else's: for a signed-in shopper the account copy is the real
     one, so dropping the local copy costs nothing, and it is the safe way to
     read an ambiguous case. */
  function resetLocal() {
    var kill = [K_IDX, K_WATCH, K_LEGACY, K_META, K_DIRTY, 'll_watchlist_snap'];
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i);
        if (k && k.indexOf('ll_watchlist_c_') === 0) kill.push(k);
      }
    } catch (e) {}
    kill.forEach(function (k) { try { localStorage.removeItem(k); } catch (e) {} });
    try {
      document.dispatchEvent(new CustomEvent('ll:watchlist:change', {
        detail: { list: [], source: 'sync' }
      }));
    } catch (e) {}
  }

  function claimStorage() {
    var stored = readJSON(K_IDX, null);
    if (!stored || typeof stored !== 'object') return;

    var owner = ('o' in stored) ? stored.o : undefined;
    var me = cfg.customerId || null;
    if (owner === me) return;

    /* guest list + now signed in = the same person. Keep it and let it merge. */
    if (owner === null && me) return;

    resetLocal();
  }

  function boot() {
    claimStorage();

    var local = readIdx();

    /* Persist the index once so the flat-array migration is not redone on
       every page, and so a later login has timestamps to merge with rather
       than a bare list. */
    if (!readJSON(K_IDX, null)) writeIdx(local, 'local');

    if (!cfg.customerId) {
      setState('guest');
      return;
    }

    /* The account list lives on the server, so ask for it. The page has
       already painted from localStorage by now, which is why this being a
       request rather than a Liquid-rendered seed is not felt: a returning
       device shows the right list immediately and this only reconciles it.
       A brand new device is the one case that waits for the round trip.

       pull() folds the answer in and pushes back anything we hold that the
       account does not - which is exactly the guest-list-on-login case. */
    pull(true).then(function () {
      if (isDirty()) schedulePush(0);
      noteActivity();   /* starts the poll loop, fast for the first minute */
    });
  }

  /* ---- public API (hubs, PDP bells, watchlist page) -------------------- */

  window.llWatchSync = {
    customerId: cfg.customerId,
    read: function () { return toList(readIdx()); },
    write: function (list, opts) {
      opts = opts || {};
      var next = applyList(list, opts.updatedAt || now());
      var out = writeIdx(next, opts.fromCloud ? 'sync' : 'local');
      if (!opts.skipCloud) schedulePush();
      return out;
    },
    add: function (handle) {
      var idx = readIdx();
      var h = clean(handle);
      if (!h) return toList(idx);
      idx[h] = now();
      var out = writeIdx(idx, 'local');
      schedulePush();
      return out;
    },
    remove: function (handle) {
      var idx = readIdx();
      var h = clean(handle);
      if (!h) return toList(idx);
      idx[h] = -now();
      var out = writeIdx(idx, 'local');
      schedulePush();
      return out;
    },
    push: function () { return push(0); },
    pull: function () { return pull(true); },
    state: function () { return syncState; }
  };

  /* Anything that writes the plain array and fires the event still syncs -
     we diff the array against the index and record the difference as real
     add / remove events. */
  document.addEventListener('ll:watchlist:change', function (ev) {
    if (selfWrite) return;
    if (!cfg.customerId) return;
    var src = ev && ev.detail && ev.detail.source;
    if (src === 'sync') return;
    var list = (ev && ev.detail && isArr(ev.detail.list)) ? ev.detail.list : readJSON(K_WATCH, []);
    var next = applyList(list, now());
    if (sig(next) !== sig(readIdx())) writeIdx(next, 'local');
    schedulePush();
  });

  /* Another tab on this same device changed things. */
  window.addEventListener('storage', function (e) {
    if (!e || (e.key !== K_WATCH && e.key !== K_IDX && e.key !== K_LEGACY)) return;
    var list = toList(readIdx());
    try {
      document.dispatchEvent(new CustomEvent('ll:watchlist:change', {
        detail: { list: list, source: 'sync' }
      }));
    } catch (err) {}
  });

  /* Coming back to a tab that has been sitting there while the phone was busy.
     Check straight away rather than waiting for the next poll tick, and stop
     polling entirely while the tab is in the background. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      clearTimeout(pollTimer);
      return;
    }
    probe();
    if (isDirty()) schedulePush(0);
    noteActivity();
  });
  window.addEventListener('pageshow', function (e) {
    if (e && e.persisted) pull(true);
  });
  window.addEventListener('online', function () {
    if (isDirty()) schedulePush(0);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
